import { render, staticRenderFns } from "./Contact_Textmessages.vue?vue&type=template&id=1c635c8f&scoped=true&"
import script from "./Contact_Textmessages.vue?vue&type=script&lang=ts&"
export * from "./Contact_Textmessages.vue?vue&type=script&lang=ts&"
import style0 from "./Contact_Textmessages.vue?vue&type=style&index=0&id=1c635c8f&lang=scss&scoped=true&"
import style1 from "./Contact_Textmessages.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c635c8f",
  null
  
)

export default component.exports